import { Vue, i18n, wemeikPopup } from './core'
import { DateTime } from 'luxon'
import { convertToCurrency, dateTimeToString } from '../utils/functions'
import Cart from './components/Cart'
import checkoutStore from './stores/checkout'
import Rails from '@rails/ujs'
import SecureImage from './components/SecureImage'
import AddressChunk from './components/AddressChunk'

document.addEventListener('DOMContentLoaded', () => {
  const $el = document.getElementById('checkout-form')

  if ($el) {
    const ACCOMPANIMENTS_URL = $el.dataset.accompanimentsUrl
    const ADDRESSES_URL = $el.dataset.addressesUrl
    const UNLOGGED = ($el.dataset.unlogged === 'true')
    const ct = DateTime.now().plus({ minutes: 45 })

    new Vue({
      i18n,
      el: $el,
      data: {
        minDeliveryDate: ct.toISODate(),
        cartStore: window.cartStore.state,
        checkoutStore: checkoutStore.state,
        company: {},
        accompaniment: {},
        accompanimentDetails: [],
        addresses: [],
        selectedItem: {},
        maxQuantitySelectedItem: 0
      },
      components: { Cart, SecureImage, AddressChunk },
      watch: {
        accompaniment: {
          deep: true,
          handler () {
            if (typeof this.accompaniment === 'object' && Array.isArray(this.accompaniment.details) && this.accompaniment.details.length > 0) {
              this.prepareAccompanimentsToShow()
            }
          }
        },
        checkoutStore: {
          deep: true,
          handler () {
            checkoutStore.setCheckoutSettings(this.checkoutStore)
          }
        }
      },
      mounted () {
        this.getAddresses()
        this.getAccompaniments()

        const nameField = document.querySelector('#order_customer_name')
        if (!this.checkoutStore.customerName || nameField) {
          if (nameField && nameField.dataset.value) {
            this.checkoutStore.customerName = nameField.dataset.value
          }
        }

        const mobileField = document.querySelector('#order_customer_mobile')
        if (!this.checkoutStore.customerMobile || mobileField) {
          if (mobileField && mobileField.dataset.value) {
            this.checkoutStore.customerMobile = mobileField.dataset.value
          }
        }
      },
      computed: {
        hasItems () {
          return (Array.isArray(this.cartStore.items) && this.cartStore.items.length > 0) || this.cartStore.count > 0
        },
        totalWithDelivery () {
          return this.cartStore.total + ((this.company.variable_delivery_cost || ['order_now', 'pickup'].includes(this.checkoutStore.deliveryType)) ? 0 : parseFloat(this.company.default_delivery_cost))
        }
      },
      methods: {
        addItem (item) {
          window.cartStore.addItem(item)
        },
        convertToCurrency: convertToCurrency,
        dateTimeToString: dateTimeToString,
        getAccompaniments () {
          const self = this
          Rails.ajax({
            url: ACCOMPANIMENTS_URL,
            type: 'GET',
            dataType: 'json',
            success: (accompanimentsInfo) => {
              self.accompaniment = accompanimentsInfo
            },
            error: (error) => {
              console.error('Error getting accompaniments: ', error)
            }
          })
        },
        getAddresses () {
          if (UNLOGGED) return

          Rails.ajax({
            url: ADDRESSES_URL,
            type: 'GET',
            dataType: 'json',
            success: (addresses) => {
              this.setAddresses(addresses)
            },
            error: (error) => {
              console.error('Error getting addresses: ', error)
            }
          })
        },
        focusField (selector) {
          try {
            document.querySelector(selector).focus()
          } catch (error) { }
        },
        getProduct (item) {
          const self = this
          const id = item.id
          this.maxQuantitySelectedItem = item.maximum_quantity
          Rails.ajax({
            url: 'products/' + id + '.json',
            type: 'GET',
            dataType: 'JSON',
            success: (data) => {
              self.selectedItem = Object.assign({}, self.selectedItem, data)
              self.selectedItem.quantity = 1
              self.selectedItem.product_id = id
              window.jQuery('#itemFormModalAccompaniment').modal()
            },
            error: (error) => {
              console.error('Error getting product: ', error)
            }
          })
        },
        isValid () {
          const { address, cash, customerMobile, customerName, deliveryDate, deliveryTime, deliveryType, localityId, paymentMethod, sectionAndPlace } = this.checkoutStore
          const deliveryDatetime = DateTime.fromFormat(`${deliveryDate} ${deliveryTime}`, 'yyyy-MM-dd HH:mm')

          if (!['order_now', 'pickup'].includes(deliveryType) && (!localityId || !address)) {
            if (!localityId) {
              wemeikPopup({
                title: this.$t('order.errors.missing_locality'),
                text: this.$t('order.messages.select_locality'),
                icon: 'error',
                buttons: {
                  cancel: this.$t('action.cancel'),
                  confirm: this.$t('action.i_get_it')
                },
                dangerMode: false
              })
                .then(() => {
                  this.focusField('#locality')
                })

              return false
            }

            wemeikPopup({
              title: this.$t('order.errors.missing_address'),
              text: this.$t('order.messages.select_address'),
              icon: 'error',
              buttons: {
                cancel: this.$t('action.cancel'),
                confirm: this.$t('action.i_get_it')
              },
              dangerMode: false
            })
              .then(() => {
                this.focusField('#address')
              })

            return false
          } else if (this.company.max_items_by_order > 0 && this.cartStore.count > this.company.max_items_by_order) {
            wemeikPopup({
              title: this.$t('order.we_sorry'),
              text: this.$t('order.messages.maximum_quantity_of_items', { maximum_quantity: this.company.max_items_by_order }),
              icon: 'error',
              dangerMode: true
            })

            return false
          } else if (deliveryType === 'order_now' && !sectionAndPlace) {
            const message = document.createElement('p')
            message.className = 'text-justify'
            message.innerHTML = this.$t('order.messages.enter_code')

            wemeikPopup({
              title: this.$t('order.we_need_code'),
              content: message,
              icon: 'error',
              dangerMode: false
            }).then(() => {
              this.focusField('#section-and-place-code')
            })

            return false
          } else if (!['order_now', 'pickup'].includes(deliveryType) && paymentMethod === 'cash' && (cash === '' || parseFloat(cash) < this.totalWithDelivery)) {
            wemeikPopup({
              title: this.$t('order.check_your_money'),
              text: this.$t('order.messages.enter_value', { total: convertToCurrency(this.totalWithDelivery) }),
              icon: 'error',
              dangerMode: false
            }).then(() => {
              this.focusField('#cash-amount')
            })

            return false
          } else if (this.company.minimum_order_value > this.cartStore.total) {
            wemeikPopup({
              title: this.$t('order.add_more_items'),
              text: this.$t('order.messages.add_more_than', { price: convertToCurrency(this.company.minimum_order_value - this.cartStore.total) }),
              icon: 'error',
              buttons: {
                cancel: this.$t('action.close'),
                confirm: this.$t('action.back_to_store')
              },
              dangerMode: false
            })
              .then((willBack) => {
                if (willBack) {
                  window.location.href = '/products'
                }
              })
              .catch((error) => {
                console.error(error)
              })

            return false
          } else if (!customerMobile || customerMobile.match(/[a-z]|'|\s/gi)) {
            wemeikPopup({
              title: this.$t('order.check_your_phone'),
              text: '',
              icon: 'error',
              dangerMode: false
            }).then(() => {
              this.focusField('#customer-mobile')
            })

            return false
          } else if (customerMobile.length < 10) {
            wemeikPopup({
              title: this.$t('order.phone_has_less_than_ten_digits'),
              text: '',
              icon: 'error',
              dangerMode: false
            }).then(() => {
              this.focusField('#customer-mobile')
            })

            return false
          } else if (!customerName) {
            wemeikPopup({
              title: this.$t('order.messages.enter_name'),
              text: '',
              icon: 'error',
              dangerMode: false
            }).then(() => {
              this.focusField('#customer-name')
            })

            return false
          } else if (['delivery_later', 'pickup'].includes(deliveryType)) {
            if (!deliveryDatetime) {
              wemeikPopup({
                title: this.$t('order.select_datetime'),
                text: '',
                icon: 'error',
                dangerMode: false
              }).then(() => {
                this.focusField('#delivery-date')
              })

              return false
            } else if (ct >= deliveryDatetime) {
              wemeikPopup({
                title: this.$t('order.change_datetime'),
                text: this.$t('order.errors.dont_datetime_before_than', { datetime: this.dateTimeToString(ct.toJSDate()) }),
                icon: 'error',
                dangerMode: true
              }).then(() => {
                this.focusField('#delivery-time')
              })

              return false
            }
          }

          return true
        },
        prepareAccompanimentsToShow () {
          let accompaniments = []

          if (this.accompaniment.condition === 'show_everything_always') {
            accompaniments = this.accompaniment.details
          } else {
            this.accompaniment.details.forEach(accompaniment => {
              const index = this.cartStore.items.findIndex(item => item.product_id === accompaniment.id)
              if (index < 0) {
                accompaniments.push(accompaniment)
              }
            })
          }

          if (accompaniments.length > 0) {
            this.accompanimentDetails = accompaniments
            window.jQuery('#modalAccompaniment').modal()
          }
        },
        prepareOrder () {
          let address = this.checkoutStore.address
          if (this.checkoutStore.addressExtra) {
            address += `, ${this.checkoutStore.addressExtra}`
          }
          let deliveryDatetime = DateTime.fromFormat(`${this.checkoutStore.deliveryDate} ${this.checkoutStore.deliveryTime}`, 'yyyy-MM-dd HH:mm')
          deliveryDatetime.setZone(this.checkoutStore.deliveryTimeZone)
          deliveryDatetime = deliveryDatetime.toUTC()
          const orderPrepared = {
            customer: {
              address: this.checkoutStore.address,
              address_extra: this.checkoutStore.addressExtra,
              details: {
                first_name: this.checkoutStore.customerName,
                mobile: this.checkoutStore.customerMobile
              }
            },
            order: {
              details: [],
              address: address,
              locality_id: this.checkoutStore.localityId,
              branch_id: this.checkoutStore.branchId,
              cash: this.checkoutStore.cash,
              delivery_date: deliveryDatetime.toFormat('yyyy-MM-dd'),
              delivery_time: deliveryDatetime.toFormat('HH:mm'),
              delivery_type: this.checkoutStore.deliveryType,
              number_of_items: this.cartStore.count,
              observation: this.checkoutStore.observation,
              payment_method: this.checkoutStore.paymentMethod,
              time_zone: this.checkoutStore.deliveryTimeZone,
              total: this.cartStore.total
            },
            spc: this.checkoutStore.sectionAndPlace
          }

          this.cartStore.items.forEach((i) => {
            orderPrepared.order.details.push({
              product_id: i.product_id,
              name: i.name,
              quantity: i.quantity,
              fraction_id: i.fraction_id,
              price: i.price,
              total: i.total,
              additionals: i.additionals.filter(a => a.checked).map(a => { return { id: a.id } }),
              observations: i.observations.filter(i => i.checked).map(i => { return { id: i.id } })
            })
          })

          return orderPrepared
        },
        setAddresses (addresses = []) {
          this.addresses = addresses.map((a) => {
            a.checked = (a.address + ', ' + a.extra) === checkoutStore.currentDeliveryAddress()
            return a
          })
        },
        setAddress (addressIndex) {
          const selectedAddress = Object.assign({}, this.addresses[addressIndex])

          this.addresses = this.addresses.map((a, i) => {
            a.checked = i === addressIndex
            return a
          })

          this.checkoutStore.address = selectedAddress.address
          this.checkoutStore.addressExtra = selectedAddress.extra
          this.checkoutStore.localityId = selectedAddress.locality_id

          wemeikPopup({
            title: this.$t('alert.success'),
            text: this.$t('address.selected'),
            icon: 'success',
            timer: 3000
          })
        },
        setDeliveryTime () {
          const deliveryTime = DateTime.now().plus({ minutes: 45 })
          const inputTime = document.getElementById('order_delivery_time')
          const inputDate = document.getElementById('order_delivery_date')
          inputTime.value = deliveryTime.toFormat('HH:mm')
          inputDate.value = deliveryTime.toISODate()
        },
        submit (e) {
          e.preventDefault()
          e.stopPropagation()

          if (this.isValid()) {
            const form = e.target
            Rails.ajax({
              url: form.action,
              type: 'POST',
              dataType: 'json',
              data: window.jQuery.param(this.prepareOrder()),
              beforeSend: () => {
                wemeikPopup({
                  title: this.$t('processing'),
                  text: this.$t('warning.please_wait'),
                  icon: 'info'
                })
                return true
              },
              success: (createdOrder) => {
                window.cartStore.empty()
                checkoutStore.setCheckoutSettings({
                  paymentMethod: 'cash',
                  cash: 0,
                  observation: '',
                  deliveryDate: '',
                  deliveryTime: ''
                })

                window.location.href = `/orders/${createdOrder.id}`
              },
              error: (error) => {
                console.error('Error creating order: ', error)
                wemeikPopup.close()
                const message = document.createElement('div')
                message.classList.add('swal-text')
                message.classList.add('my-0')
                message.innerHTML = `${error.error === undefined ? this.$t('error.creating_order') : error.error !== undefined ? error.error : ''}`
                wemeikPopup({
                  title: this.$t('alert.error'),
                  icon: 'error',
                  content: message
                })
              }
            })
          }
        }
      }
    })
  }
})
